import React, { useState, useEffect } from 'react';
import { ref, set, get, update, remove, child, onValue, query, orderByChild } from "firebase/database";
import { Modal, Col, Row, Button } from 'react-bootstrap';
import { createUserWithEmailAndPassword, onAuthStateChanged } from '@firebase/auth';
import StartFirebase, { auth } from "../services/firebaseConfig";

const Register = (props) => {
    const { show, handleClose, user } = props
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [userName, setUserName] = useState('');
    const db = StartFirebase();
    const [tempUser, setTempUser] = useState({});

    const insertName = (tempUser) => {
        //ref(db, '/picks/' + user.uid + '/week/'+weekNum+'/');
        try {
            if (tempUser !== undefined || tempUser.uid !== undefined) {
                var setName = userEmail;
                if (userName.length > 0) {
                    setName = userName;
                };
                set(ref(db, '/users/' + tempUser.uid), { "name": setName });

            }
            setUserEmail("");
            setUserPassword("");
            setUserName("");
            handleClose();
        } catch (error) { console.log(error.message); }
    }

    const register = async () => {
        try {
            const { user } = await createUserWithEmailAndPassword(
                auth,
                userEmail,
                userPassword
            );
            insertName(user);
        } catch (error) {
            if (error.code === "auth/email-already-in-use") {
                alert("Email address already used.");
            }
            else if (error.code === "auth/invalid-email") {
                alert("Invalid email address.");
            }
            else if (error.code === "auth/weak-password") {
                alert("Password is too weak.");
            }
            else if (error.code === "auth/internal-error") {
                alert("Error. Make sure you provided email and password.");
            }
            console.log(error.code);
        }
    }

    return (
        <>
            <Modal fullscreen='md-down' show={show} onHide={handleClose} style={{ zIndex: '99999' }} className="registerModal">
                <Modal.Header closeButton>
                    <Modal.Title className="modalTitle">Register New User</Modal.Title>
                </Modal.Header>
                <Modal.Body className="registerModalBody">
                    <div>
                        <table className="userLoginRegister">
                            <tr><td><div className="registerIntro">Email and password will be how you log in to the site. Display name can be anything (within reason) that you wish to be labeled on the leaderboard. Leaving display name blank will default to email.</div></td></tr>
                            <tr><td><input name="RegisterEmail" placeholder="Email..." value={userEmail} onChange={(event) => { setUserEmail(event.target.value); }} /></td></tr>
                            <tr><td><input name="RegisterPassword" placeholder="Password..." value={userPassword} onChange={(event) => { setUserPassword(event.target.value); }} /></td></tr>
                            <tr><td><input name="CreateName" placeholder="Display Name..." value={userName} onChange={(event) => { setUserName(event.target.value); }} /></td></tr>
                            <tr><td><Button className="loginButton" variant="primary" size="md" onClick={register}>Register</Button></td></tr>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
        );
}

export default Register;